import useMe from "utils/useMe"

export function useIsNSFWHidden(participation) {
  const me = useMe()
  if (!("tags" in participation)) {
    throw new Error(`Found no \`tags\` attribute @ participation ${JSON.stringify(participation)}`)
  }
  return participation.tags.indexOf("nsfw") !== -1 && (!me || me.age < 18)
}
